<div class="redirect-modal">
  @if (!isSignupComplete) {
    <div class="loading-animation">
      <onsip-animation [loop]="true" filename="loading_cropped"></onsip-animation>
    </div>
    <h4 mat-dialog-title>Please wait...</h4>
    <h5 mat-dialog-content>{{ subtitle }}</h5>
  }
  @if (isSignupComplete) {
    <div class="loading-animation">
      <onsip-animation [loop]="true" filename="success_cropped"></onsip-animation>
    </div>
    <h4 mat-dialog-title>All set!</h4>
    <div mat-dialog-content>
      <h5 class="complete-paragraph">
        {{ "ONSIP_I18N.THANKS_FOR_SIGNING_UP_FOR_ONSIP" | translate }}
      </h5>
      <h5 class="complete-paragraph">
        {{ "ONSIP_I18N.WE_JUST_SENT_YOU_AN_EMAIL_WITH_IMPORTANT_LOGIN_INFO" | translate }}
      </h5>
      <h5 class="complete-paragraph">
        {{ "ONSIP_I18N.CHECK_YOUR_INBOX_TO_GET_STARTED" | translate }}
      </h5>
    </div>
    <div mat-dialog-actions class="modal-actions">
      <button mat-raised-button color="primary" (click)="redirectToApp()">
        <span> Log in now </span>
      </button>
    </div>
  }
</div>
